import { useState } from 'react';
import posthog from 'posthog-js';
import { useEffectOnce } from 'react-use';
import { NEXT_PUBLIC_POSTHOG_API_KEY, NEXT_PUBLIC_POSTHOG_DOMAIN } from '../constants/main';

const TENANT = 'tenant';

type Context = {
    brand: string;
    market: string;
    locale: string;
    channel?: string;
};

type UsePosthog = (sessionId: string | null, context: Context) => { isLoaded: boolean };

export const usePosthog: UsePosthog = (sessionId, context) => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffectOnce(() => {
        posthog.init(NEXT_PUBLIC_POSTHOG_API_KEY, {
            api_host: NEXT_PUBLIC_POSTHOG_DOMAIN,
            persistence: 'memory',
            disable_session_recording: true,
            disable_persistence: true,
            loaded: () => {
                if (sessionId) {
                    posthog.identify(sessionId);
                }

                const groupKey = Object.values(context).join('-');

                posthog.group(TENANT, groupKey, context);
            },
        });

        setIsLoaded(true);
    });

    return { isLoaded };
};

type ExperimentData = {
    trigger: string;
    page: string;
    action?: string | null;
    customer?: string | null;
    position?: string | null;
};
export const pushTriggerToPosthog = (data: ExperimentData) => {
    posthog.capture(data.trigger, {
        page: data.page,
        action: data?.action,
        customer: data?.customer,
        position: data?.position,
    });
};
